import React, { Component } from 'react';
import './ConversationalSearch.css';

class ConversationalSearch extends Component {
    state = {
        query: '',
        loading: false,
        error: null,
        appliedQuery: null,
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const query = this.state.query.trim();
        if (!query) return;

        this.setState({ loading: true, error: null });

        try {
            await this.props.onSearch(query);
            this.setState({ appliedQuery: query });
        } catch (err) {
            this.setState({ error: err.message || 'Erro ao processar busca.' });
        } finally {
            this.setState({ loading: false });
        }
    };

    handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            this.handleSubmit(e);
        }
    };

    handleClear = () => {
        this.setState({ query: '', appliedQuery: null, error: null });
        if (this.props.onClear) {
            this.props.onClear();
        }
    };

    render() {
        const { query, loading, error, appliedQuery } = this.state;

        return (
            <div className="conversational-search p-3">
                <div className="conversational-search__header mb-3">
                    <span className="conversational-search__badge">
                        <i className="fas fa-robot mr-1"></i> IA
                    </span>
                    <h6 className="mb-0 d-inline ml-2 font-weight-bold">Busca por linguagem natural</h6>
                    <p className="text-muted small mt-1 mb-0">
                        Descreva o que você quer ver no mapa em suas próprias palavras.
                    </p>
                </div>

                <form onSubmit={this.handleSubmit}>
                    <div className="form-group mb-2">
                        <textarea
                            className="form-control conversational-search__textarea"
                            placeholder={'Ex: "Apartamentos de 2 ou 3 quartos em comercialização no bairro Ahú em Curitiba, alto padrão" ou "Empreendimentos horizontais lançados em 2023 em Londrina até 500 mil"'}
                            value={query}
                            onChange={(e) => this.setState({ query: e.target.value, error: null })}
                            onKeyDown={this.handleKeyDown}
                            rows={4}
                            disabled={loading}
                        />
                    </div>

                    <div className="d-flex gap-2">
                        <button
                            type="submit"
                            className="btn btn-primary btn-sm flex-fill"
                            disabled={loading || !query.trim()}
                        >
                            {loading ? (
                                <>
                                    <i className="fas fa-spinner fa-spin mr-1"></i>
                                    Interpretando...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-search mr-1"></i>
                                    Buscar
                                </>
                            )}
                        </button>
                        {appliedQuery && (
                            <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm"
                                onClick={this.handleClear}
                                title="Limpar busca"
                            >
                                <i className="fas fa-times"></i>
                            </button>
                        )}
                    </div>
                </form>

                {error && (
                    <div className="alert alert-danger mt-2 mb-0 py-2 small">
                        <i className="fas fa-exclamation-circle mr-1"></i>
                        {error}
                    </div>
                )}

                {appliedQuery && !error && (
                    <div className="conversational-search__applied mt-2">
                        <i className="fas fa-check-circle mr-1 text-success"></i>
                        <span className="small text-muted">Filtros aplicados para: </span>
                        <em className="small">"{appliedQuery}"</em>
                    </div>
                )}

                <div className="conversational-search__hint mt-3">
                    <p className="small text-muted mb-1"><strong>Exemplos de busca:</strong></p>
                    <ul className="small text-muted pl-3 mb-0">
                        <li>Apartamentos de 2 quartos em Curitiba até R$ 400 mil</li>
                        <li>Empreendimentos Verticais no Água Verde em Curitiba lançados em 2024</li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default ConversationalSearch;
